module.exports = __webpack_public_path__ + "static/media/iconAlert.f33087f3.svg";